import {
  AssembleiaAssessorRoutePath,
  LiberarPautaEmLoteAssessorRoutePath,
  ReordenarPautasRoutePath,
  VerificarInconsistenciaAssessorRoutePath,
  VotacaoPresencialRoutePath,
} from 'library/Routes';
import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import LiberarPautasEmLote from './Etapas/LiberarPautasEmLote/LiberarPautasEmLote';
import PautasDoEvento from './Etapas/PautasDoEvento/PautasDoEvento';
import ReordenarPautas from './Etapas/ReordenarPautas/ReordenarPautas';
import VerificarInconsistencia from './Etapas/VerificarInconsistencia/VerificarInconsistencia';
import VotacaoPresencial from './Etapas/VotacaoPresencial/VotacaoPresencial';
export default function Evento() {
  return (
    <Fragment>
      <Route
        path={AssembleiaAssessorRoutePath}
        component={PautasDoEvento}
        exact
      />
      <Route
        path={LiberarPautaEmLoteAssessorRoutePath}
        component={LiberarPautasEmLote}
        exact
      />
      <Route
        path={VerificarInconsistenciaAssessorRoutePath}
        component={VerificarInconsistencia}
        exact
      />
      <Route
        path={VotacaoPresencialRoutePath}
        component={VotacaoPresencial}
        exact
      />
      <Route
        path={ReordenarPautasRoutePath}
        component={ReordenarPautas}
        exact
      />
    </Fragment>
  );
}
